const apiBaseUrl = process.env.REACT_APP_HOST_API_KEY
const appName = process.env.REACT_APP_NAME;
const appAlgorithmKey=process.env.REACT_APP_ENCRYPTION_KEY;

export { apiBaseUrl, appName,appAlgorithmKey };

